import { NgModule }           from '@angular/core';
import { FormInputComponent } from '@app/shared/form-elements/form-input/form-input.component';
import { InputNumberModule }  from '@shared/components/inputs/input-number/input-number.module';
import { FormElementsModule } from '@shared/form-elements/form-elements.module';

@NgModule( {
	declarations: [
		FormInputComponent
	],
	imports: [
		FormElementsModule,
		InputNumberModule
	],
	exports: [
		FormInputComponent
	]
} )
export class FormInputModule {}
